<template>
  <div>
    <div v-if="activationsOCRHistory === 'false'">
      <h3 class="title-content">Históricos</h3>
      <v-card class="form-card">
        <v-form ref="formHistory">
          <v-col v-if="hasData" class="px-0">
            <v-row>
              <v-col cols="12" sm="4">
                <v-select
                    v-model="filter.period"
                    :items="periods"
                    label="Período"
                    item-text="value"
                    return-object
                    @change="search"
                    outlined
                    dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" v-if="showWallets === 'true' && advancedWalletOptions === 'true'">
                <v-select
                    v-model="filter.wallet"
                    :items="wallets"
                    item-text="name"
                    label="Carteira (Opcional)"
                    clearable
                    return-object
                    @change="search"
                    outlined
                    dense
                ></v-select>
              </v-col>
              <v-col cols="12" :sm="showWallets === 'true' && advancedWalletOptions === 'true' ? 4 : 8">
                <v-select
                    v-model="filter.vehicle"
                    :items="vehicles"
                    item-text="plate"
                    label="Veículo (Opcional)"
                    clearable
                    return-object
                    @change="search"
                    outlined
                    dense
                ></v-select>
              </v-col>
            </v-row>

            <v-layout v-resize="onResize">
              <v-col class="px-0">
                <v-data-table
                    :hide-default-header="isMobile"
                    :headers="headers"
                    :items="rows"
                    :loading="loading"
                    :items-per-page="50"
                    locale="pt-BR"
                    :hide-default-footer="rows.length === 0 || rows.length < 10"
                    class="elevation-1 clickable-table"
                >
                  <template v-slot:item.type="{ item }">
                    <div @click="openTransactionDetails(item)" class="clickable-cell">
                      <template v-if="item.type === 17">
                        Regularização do veículo {{ item.plate }}
                      </template>
                      <template v-else-if="item.type === 6">
                        Estacionamento {{ item.plate }}
                      </template>
                      <template v-else>
                        {{ item.type_name }}
                      </template>
                    </div>
                  </template>
                  <template v-slot:item.created_at="{ item }">
                    <div @click="openTransactionDetails(item)" class="clickable-cell">
                      {{ item.created_at | timeStampToHuman }}
                    </div>
                  </template>
                  <template v-slot:item.payment_form_name="{ item }">
                    <div @click="openTransactionDetails(item)" class="clickable-cell">
                      {{ item.payment_form_name }}
                    </div>
                  </template>
                  <template v-slot:item.amount="{ item }">
                    <div @click="openTransactionDetails(item)" class="clickable-cell">
                      R$ {{ item.amount | integerToMoney | integerToMoney2 }}
                    </div>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div @click="openTransactionDetails(item)" class="clickable-cell text-center">
                      <i class="fas fa-search"></i>
                    </div>
                  </template>
                  <template slot="no-data">
                    Nenhum dado encontrado.
                  </template>
                  <template slot="loading">
                    Carregando
                  </template>
                </v-data-table>
              </v-col>
            </v-layout>
          </v-col>

          <div class="message-data text-center" v-show="!hasData && !loading">
            <i class="far fa-bell"></i>
            <span>Você não possui nenhum dado cadastrado.</span>
          </div>
        </v-form>
      </v-card>
    </div>

    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        bottom
        right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <transaction-details-dialog
        v-model="detailsDialog.show"
        :transaction-id="detailsDialog.transactionId"
        @show-snackbar="showSnackbar"
        @request-pdf="handlePdfRequest"
    />

    <v-dialog v-model="pdfHandler.show" max-width="500" persistent>
      <pdf-handler
          v-if="pdfHandler.show"
          :url="pdfHandler.url"
          @close="pdfHandler.show = false"
          @show-snackbar="showSnackbar"
      />
    </v-dialog>

  </div>
</template>

<script>
import '../filters';
import axios from 'axios';
import moment from 'moment';
import TransactionDetailsDialog from '../components/Details/TransactionDetailsDialog';
import PdfHandler from '../components/Pdf/PdfHandler';

export default {
  name: "History",
  components: {
    TransactionDetailsDialog,
    PdfHandler
  },
  data() {
    return {
      isMobile: false,
      filter: {
        wallet: null,
        vehicle: null,
        period: null
      },
      periods: [
        {label: 0, value: 'Todo o período'},
        {label: 1, value: 'Hoje'},
        {label: 2, value: 'Os últimos 7 dias'},
        {label: 3, value: 'Esse mês'},
        {label: 4, value: 'Mês anterior'},
        {label: 5, value: 'Esse ano'}
      ],
      wallets: [],
      vehicles: [],
      loading: false,
      snackbar: {
        show: false,
        text: '',
        color: 'success',
        timeout: 4000
      },
      detailsDialog: {
        show: false,
        transactionId: null
      },
      pdfHandler: {
        show: false,
        url: null
      },
      headers: [
        {text: 'Operação', sortable: false, filter: false, value: 'type'},
        {text: 'Data', sortable: false, filter: false, value: 'created_at'},
        {text: 'Forma de Pagamento', sortable: false, filter: false, value: 'payment_form_name'},
        {text: 'Valor', sortable: false, filter: false, value: 'amount'},
        {text: 'Ações', sortable: false, filter: false, value: 'actions', align: 'center'}
      ],
      rows: []
    };
  },
  computed: {
    advancedWalletOptions() {
      return process.env.VUE_APP_ADVANCED_WALLET_OPTIONS;
    },
    showWallets() {
      return process.env.VUE_APP_SHOW_WALLETS;
    },
    activationsOCRHistory() {
      return process.env.VUE_APP_ACTIVATIONS_OCR_HISTORY;
    },
    userId() {
      return JSON.parse(localStorage.getItem('user')).id;
    },
    hasData() {
      return this.wallets.length > 0 || this.vehicles.length > 0;
    }
  },
  mounted() {
    this.loadInitialData();
  },
  methods: {
    showSnackbar(text, color = 'success') {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
    openTransactionDetails(transaction) {
      this.detailsDialog.transactionId = transaction.transaction_id;
      this.detailsDialog.show = true;
    },
    handlePdfRequest(url) {
      this.pdfHandler.url = url;
      this.pdfHandler.show = true;
    },
    async loadInitialData() {
      this.loading = true;

      try {
        await Promise.all([
          this.loadWallets(),
          this.loadVehicles()
        ]);

        this.filter.period = this.periods[0];
        this.search();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async loadWallets() {
      try {
        const response = await axios.get('/api/users/driver/me/wallet');
        this.wallets = response.data.data;
      } catch (error) {
        console.error('Erro ao carregar carteiras:', error);
      }
    },
    async loadVehicles() {
      try {
        const response = await axios.get('/api/users/driver/me/plate');
        this.vehicles = response.data.data.filter(vehicle => {
          return vehicle.wallet !== null && this.userId === vehicle.wallet.user_id;
        });
      } catch (error) {
        console.error('Erro ao carregar veículos:', error);
      }
    },
    buildFilterParams() {
      const params = {};

      if (this.filter.wallet && this.filter.wallet.id) {
        params.wallet = this.filter.wallet.id;
      }

      if (this.filter.vehicle && this.filter.vehicle.plate) {
        params.plate = this.filter.vehicle.plate;
      }

      const periodLabel = this.filter.period.label;

      switch (periodLabel) {
        case 1:
          params.created_at_begin = moment().format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 2:
          params.created_at_begin = moment().subtract('7', 'days').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 3:
          params.created_at_begin = moment().startOf('month').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 4:
          params.created_at_begin = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 5:
          params.created_at_begin = moment().startOf('year').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().endOf('year').format('YYYY-MM-DD 23:59:59');
          break;
      }

      return params;
    },
    search() {
      this.rows = [];
      const params = this.buildFilterParams();

      this.loading = true;

      axios.get('/api/users/driver/me/app/transaction', {params})
          .then(res => {
            this.rows = res.data.data;
          })
          .catch(() => {
            this.showSnackbar('Erro ao buscar histórico. Tente novamente.', 'error');
          })
          .finally(() => {
            this.loading = false;
          });
    }
  }
};
</script>

<style scoped>
th, td.v-data-table__mobile-row {
  padding: 0 !important;
}

.clickable-cell {
  cursor: pointer;
  padding: 12px 16px;
  width: 100%;
  height: 100%;
}

.clickable-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.export-buttons {
  gap: 8px;
}

@media only screen and (max-width: 600px) {
  .export-buttons {
    justify-content: center !important;
  }
}

@media only screen and (max-width: 500px) {
  .form-card {
    width: 90vw;
  }
}
</style>
